module.exports = __webpack_public_path__ + "img/pdf_preview_pocket_guide_en.950180c0.png";